import { FC, ReactNode } from "react";
import { Helmet } from "react-helmet";

interface SEOProps {
    title?: string;
    description?: string;
    lang?: string;
    children?: ReactNode;
}

export const SEO: FC<SEOProps> = ({
    title = "Hitta Podd - Populära Podcasts - HittaPodd.se",
    description = "Hitta podcasts att lyssna på. För oss som älskar poddar. HittaPodd.se",
    lang = "sv-se",
    children,
}) => {
    return (
        <Helmet
            htmlAttributes={{
                lang,
            }}>
            <title>{title}</title>
            <meta name="description" content={description} />
            {children}
        </Helmet>
    );
};
